import Vue from "vue";
import axios from "axios";
import NProgress from "vue-nprogress";
import { sync } from "vuex-router-sync";
import App from "./views/App.vue";
import router from "./router";
import config from "configSite";
import store from "./store";
import * as filters from "./filters";
import { TOGGLE_SIDEBAR, PUBLIC_LAYOUT } from "./store/mutation-types";
import VeeValidate from "vee-validate";
import Loading from "vue-loading-overlay";
import * as Components from "./views/components";
import VueHtmlToPaper from "vue-html-to-paper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import LazyLoadImage from "@/directives/LazyLoadDirective";
// import "./css/global_css.scss";
import "vue-loading-overlay/dist/vue-loading.css";
import Cookies from "js-cookie";
// import "./css/index.scss";
import customParseFormat from "dayjs/plugin/customParseFormat";
import fx from "utils/fx";

dayjs.extend(customParseFormat);

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
window.axios = axios;
Vue.filter("parseInteger", function(value) {
  if (value === "" || value === null || value === undefined) return;
  return fx.numberWithCommas(parseInt(value));
});

Vue.directive("lazyload", LazyLoadImage);
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});
Vue.component("v-select", vSelect);
// import Vue2Filters from 'vue2-filters';
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.3.2/css/bulma.min.css"
  ]
};

Vue.use(VueHtmlToPaper, options);
// or, using the defaults with no stylesheet

// Import stylesheet
// import "vue-loading-overlay/dist/vue-loading.min.css";
import "vue2-dropzone/dist/vue2Dropzone.css";
//add google map api

let s = document.createElement("script");
s.setAttribute(
  "src",
  "https://maps.googleapis.com/maps/api/js?libraries=places&key=" +
    config.GM_Key
);
document.head.appendChild(s);

Vue.router = router;

Vue.use(VeeValidate);
Vue.use(Loading, {
  color: "#777",
  enforceFocus: false,
  isFullPage: true,
  backgroundColor: "#fff",
  opacity: 0.9,
  container: null,
  zIndex: 999
});
// undo cmt if filter dont work
// Vue.use(Vue2Filters)

Vue.use(NProgress);

// add components
Components.init();

// Enable devtools
Vue.config.devtools = true;

sync(store, router);

const nprogress = new NProgress({ parent: ".nprogress-container" });

const { state } = store;

router.beforeEach((route, redirect, next) => {
  let cookies = Cookies.get("access_token");
  if (route.path != "/login" && cookies == undefined) {
    next("login");
    return;
  }
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false);
  }

  let bool = false;

  if (route.matched.some(record => record.meta.public)) {
    bool = true;
  }

  store.commit(PUBLIC_LAYOUT, { status: bool });

  next();
});

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

const app = new Vue({
  router,
  store,
  nprogress,
  ...App,
  watch: {
    $route(to, from) {
      let bool = false;
      if (to.matched.some(record => record.meta.public)) {
        bool = true;
      }
      store.commit(PUBLIC_LAYOUT, { status: bool });
    }
  }
});

export { app, router, store };
